export default {
  componentName: 'on-stage',
  exampleImgUrl:
    'https://drive.google.com/file/d/1kl06S-XnKFFfWMfEbmAEXY-lh343Gf6S/view',
  nickname: 'On-Stage',
  pageList: [
    'https://www.bassmaster.com/leaderboard/tournaments/2018-bassmaster-team-championship',
  ],
  renderId: 'react-app--on-stage',
};
